import { twMerge } from "tailwind-merge"

export type DoubleWordProps = {
    className?: string
    primary: string
    primaryClassName?: string
    secondary: string
    secondaryClassName?: string
}

const DoubleWord = (props: DoubleWordProps) => {

    return (
        <div 
            className={twMerge(
                "flex gap-1 text-lg font-bold",
                props.className
            )}
        >
            <span className={twMerge("text-secondary", props.primaryClassName)}>
                {props.primary}
            </span>
            <span className={twMerge("text-[#9E8F82]", props.secondaryClassName)}>
                {props.secondary}
            </span>
        </div>
    )
}

export default DoubleWord